import { type QueryParamConfig, decodeString, encodeString } from "serialize-query-params";
import type { z } from "zod";

import { fromJSON } from "~/tools/from-json";
import { toJSON } from "~/tools/to-json";

import { FormState } from "./form-state";

const QueryParam = {
	encode(value) {
		const encoded = value == null ? null : FormState.encoder(value).encode();

		if (encoded == null) {
			return undefined;
		}

		return encodeString(toJSON(encoded)) ?? undefined;
	},

	decode(raw) {
		const [, value] = fromJSON(decodeString(raw) ?? "", FormState.decoder);

		return value ?? undefined;
	},
} satisfies QueryParamConfig<z.infer<typeof FormState.decoder>>;

export { QueryParam };
